import { mergeStyleSets } from '@fluentui/react';
import { IMultiTextFiltersClassNames } from './MultiTextFilters.types';

export const getClassNames = (): IMultiTextFiltersClassNames => {
  return mergeStyleSets({
    root: {},
  });
};
